export default "__VITE_ASSET__DqwCGdoq__"